import { render, staticRenderFns } from "./View.vue?vue&type=template&id=adfe4da4&scoped=true&"
import script from "./View.vue?vue&type=script&lang=js&"
export * from "./View.vue?vue&type=script&lang=js&"
import style0 from "./View.vue?vue&type=style&index=0&lang=css&"
import style1 from "./View.vue?vue&type=style&index=1&id=adfe4da4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adfe4da4",
  null
  
)

export default component.exports